"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselSlide = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const index_js_1 = require("../utils/index.js");
const CarouselContext_js_1 = require("./CarouselContext.js");
/**
 * `CarouselSlide` is used for the actual slide content. The content can be specified through `children`.
 *
 * It is recommended that the slide content bring its own dimensions (esp. height) and that
 * the dimensions should be the same for all slides.
 */
exports.CarouselSlide = React.forwardRef((props, ref) => {
    const { index, className, children, ...rest } = props;
    const context = React.useContext(CarouselContext_js_1.CarouselContext);
    if (!context || index == null) {
        throw new Error('CarouselSlide must be used within Carousel');
    }
    const { isManuallyUpdating, setCurrentIndex } = context;
    const updateActiveIndexOnScroll = React.useCallback(() => {
        // only update index if scroll was triggered by browser
        if (!isManuallyUpdating.current) {
            setCurrentIndex(index);
        }
    }, [index, isManuallyUpdating, setCurrentIndex]);
    const intersectionRef = (0, index_js_1.useIntersection)(updateActiveIndexOnScroll, { threshold: 0.5 }, false);
    const refs = (0, index_js_1.useMergedRefs)(intersectionRef, ref);
    return (React.createElement("li", { className: (0, classnames_1.default)('iui-carousel-slider-item', className), role: 'tabpanel', "aria-roledescription": 'slide', ref: refs, ...rest }, children));
});
